import React, { useEffect } from 'react';
import { FileText } from 'lucide-react';
import { useChatContextCount } from './hooks';
import { MAX_CONTEXTS } from './chatContextSlice';

export default function MentionPopover({ open, currentPage, onPick, onClose }) {
    const count = useChatContextCount();
    const isFull = count >= MAX_CONTEXTS;

    useEffect(() => {
        if (!open) return undefined;
        const handle = (e) => {
            if (e.key === 'Escape') {
                onClose?.();
            }
        };
        window.addEventListener('keydown', handle);
        return () => window.removeEventListener('keydown', handle);
    }, [open, onClose]);

    if (!open) return null;

    const pickable = !!currentPage && !isFull;

    return (
        <div className="absolute bottom-full left-0 right-0 mb-2 z-40 w-auto max-w-96 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
            <div className="px-3 py-2 text-[11px] font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-100 bg-white">
                Trang hiện tại
            </div>
            <div className="p-1.5 bg-white">
                {currentPage ? (
                    currentPage.isLoading ? (
                        <div className="w-full flex items-center gap-2 px-2.5 py-2 bg-white">
                            <FileText className="w-4 h-4 flex-shrink-0 text-gray-300" />
                            <span className="block flex-1 h-3 rounded-full bg-gray-100 animate-pulse" />
                        </div>
                    ) : (
                        <button
                            type="button"
                            onClick={() => pickable && onPick(currentPage)}
                            disabled={!pickable}
                            className={`w-full flex items-start gap-2 px-2.5 py-2 rounded-md text-left transition-colors bg-white ${
                                pickable ? 'hover:bg-white text-gray-800' : 'opacity-60 cursor-not-allowed text-gray-500'
                            }`}
                        >
                            <FileText className="w-4 h-4 flex-shrink-0 text-gray-500 mt-0.5" />
                            <div className="flex-1 min-w-0">
                                <div className="text-sm font-medium truncate">
                                    {currentPage.label || currentPage.uri}
                                </div>
                            </div>
                        </button>
                    )
                ) : (
                    <div className="px-2.5 py-3 text-xs text-gray-400">
                        Không có context cho page hiện tại
                    </div>
                )}
                {isFull && (
                    <div className="px-2.5 pt-1 pb-1 text-[11px] text-amber-600">
                        Đã đạt tối đa {MAX_CONTEXTS} context
                    </div>
                )}
            </div>
        </div>
    );
}
